/* eslint-disable */
const LangUnregister = {
	"unregister._title": ["REMOVE MY ACCOUNT", "HỦY TÀI KHOẢN"],
	"unregister._content": [
		`<p>
			By unregister your Card, you will no longer
			be a member of Starbucks Rewards<sup>TM</sup>.
			You will be forfeiting any of the
			Stars or available rewards. Your account
			information will be removed.
		</p>`,
		`<p>
			Nếu bạn chọn hủy tài khoản, bạn sẽ không còn là thành viên của Starbucks Rewards<sup>TM</sup>. 
			Điều này đồng nghĩa tất cả điểm ngôi sao và quà thưởng bạn hiện có trong tài khoản sẽ được hủy khỏi hệ thống. Các thông tin cá nhân trong tài khoản cũng bị xóa khỏi hệ thống.
		</p>`,
	],
	"unregister._removeButton": ["Remove My Account", "Hủy tài khoản"],
	"unregister.message._hasStoreBalance": [
		"You cards still have balance. Please use it  before unregistering.",
		"Thẻ của bạn vẫn còn số dư. Hãy sử dụng hết số dư trong thẻ trước khi hủy tài khoản.",
	],
	"unregister.message._confirmation": [
		"Are you sure you want to unregister?",
		"Bạn có chắc chắn muốn hủy tài khoản không?",
	],
	"unregister.message._confirmation_": [
		"Dear ${MyName}" +
			`<br>` +
			"To complete this process, please check your email to confirm your account has been unregistered. This will ensure your account is removed from our system.",
		"Gửi ${MyName}" +
			`<br>` +
			"Vui lòng kiểm tra hộp thư bạn đã đăng ký và chọn vào đường dẫn để hoàn tất việc đồng ý xóa tài khoản khỏi chương trình. Khi bạn chọn vào đường dẫn để xác nhận, toàn bộ thông tin tài khoản của bạn sẽ được xóa khỏi hệ thống.",
	],
}

export default LangUnregister



// WEBPACK FOOTER //
// ./src/resources/pages/LangUnregister.js